module.exports = __webpack_public_path__ + "img/ob+_logo.e85a5947.svg";